import { AutoComplete, Button, Input, InputNumber, message } from "antd";
import CustomTable from "components/CustomTable";
import { useState } from "react";
import { useCatalogProducts } from "features/ProjectType/data/hooks";
import { ProjectTypeState } from "features/ProjectType/presentation/components/ProjectTypeState";
const money = (value) => Number(value || 0).toLocaleString("vi-VN");
export default function PackageProductTable({ products, onChange, errors = {}, disabled }) {
  const [keyword, setKeyword] = useState("");
  const catalog = useCatalogProducts(keyword);
  const addProduct = (value) => {
    const product = catalog.data?.items.find((row) => String(row.productId) === value);
    if (!product) return;
    if (products.some((row) => row.productId === product.productId)) {
      message.error("Sản phẩm đã có trong gói");
      return;
    }
    onChange([...products, { ...product, quantity: 1, displayLabel: null }]);
    setKeyword("");
  };
  const update = (index, values) =>
    onChange(products.map((row, rowIndex) => (rowIndex === index ? { ...row, ...values } : row)));
  const errorAt = (index, field) => errors[`products.${index}.${field}`];
  const columns = [
    { title: "STT", width: 60, render: (_, row, index) => index + 1 },
    {
      title: "SẢN PHẨM",
      render: (_, row, index) => (
        <>
          <strong>{row.productName}</strong>
          <div>{row.model}</div>
          {errorAt(index, "productId") && (
            <div role="alert" className="project-type-field-error">
              {errorAt(index, "productId")}
            </div>
          )}
        </>
      ),
    },
    {
      title: "NHÃN HIỂN THỊ",
      render: (_, row, index) => (
        <>
          <Input
            aria-label={`Nhãn hiển thị ${index + 1}`}
            value={row.displayLabel || ""}
            disabled={disabled}
            onChange={(event) => update(index, { displayLabel: event.target.value })}
          />
          {errorAt(index, "displayLabel") && (
            <div role="alert" className="project-type-field-error">
              {errorAt(index, "displayLabel")}
            </div>
          )}
        </>
      ),
    },
    {
      title: "SỐ LƯỢNG",
      width: 120,
      render: (_, row, index) => (
        <>
          <InputNumber
            aria-label={`Số lượng ${index + 1}`}
            style={{ width: 64 }}
            value={row.quantity}
            disabled={disabled}
            onChange={(quantity) => update(index, { quantity })}
          />
          {errorAt(index, "quantity") && (
            <div role="alert" className="project-type-field-error">
              {errorAt(index, "quantity")}
            </div>
          )}
        </>
      ),
    },
    { title: "ĐƠN GIÁ", width: 160, dataIndex: "unitPrice", render: money },
    { title: "THÀNH TIỀN", width: 170, render: (_, row) => money(row.quantity * row.unitPrice) },
    {
      title: "HÀNH ĐỘNG",
      width: 100,
      render: (_, row) => (
        <Button
          danger
          type="link"
          disabled={disabled}
          onClick={() => onChange(products.filter((value) => value.productId !== row.productId))}
        >
          Xóa
        </Button>
      ),
    },
  ];
  return (
    <>
      <AutoComplete
        style={{ width: 460, maxWidth: "100%", marginBottom: 16 }}
        value={keyword}
        onChange={setKeyword}
        onSelect={addProduct}
        disabled={disabled}
        placeholder="Tìm sản phẩm trong danh mục để thêm vào gói..."
        options={(catalog.data?.items || []).map((row) => ({
          value: String(row.productId),
          label: `${row.productName}${row.model ? ` · ${row.model}` : ""}`,
        }))}
        notFoundContent={
          keyword.trim().length < 2
            ? "Nhập ít nhất 2 ký tự"
            : catalog.loading
              ? "Đang tải..."
              : "Không tìm thấy sản phẩm"
        }
      />
      {catalog.error && <ProjectTypeState error={catalog.error} refetch={catalog.refetch} />}
      <CustomTable
        rowKey="productId"
        dataSource={products}
        columns={columns}
        pagination={false}
        locale={{ emptyText: "Chưa có sản phẩm. Tìm trong danh mục để thêm." }}
      />
      {/* Q-J: câu chú thích tổng nội bộ đang chờ duyệt. */}
      <div className="project-type-total">
        Tổng giá trị sản phẩm (tự cộng, chỉ để đối chiếu — khách thấy khoảng giá tham khảo ở trên):{" "}
        <strong>
          {money(products.reduce((total, row) => total + Number(row.quantity || 0) * row.unitPrice, 0))} VNĐ
        </strong>
      </div>
    </>
  );
}
